import swal from 'sweetalert2'

import { Button } from '@domain-group/suit-theme'

import { generateApplicationUrl } from '@domain-group/javascript-utils'

import useCampaign from '@hooks/useCampaign'

import type { UseCampaignPayload } from '@hooks/useCampaign'

import type { ModalCallbacks } from '@modals/SelectEmailRecipientModal'

import type { CampaignModel } from '@models/types'

import type { Recipient, UseSelectEmailRecipientModalPayload } from '../../hooks/useEmailRecipient'

type ShareLinkParams = {
  campaign: CampaignModel,
  closeModal: ModalCallbacks['closeModal'],
  completeSelection?: boolean,
  emailDashboardLink: ModalCallbacks['emailDashboardLink'],
  emailFn: UseCampaignPayload['callbacks']['emailDashboardLink'],
  linkAnchor: string,
  message: string,
  selectedRecipients: Recipient[],
  subject: string,
}

const confirmShareLink = (params: ShareLinkParams) => {
  const {
    campaign, closeModal, completeSelection, emailFn, emailDashboardLink,
    linkAnchor, message, selectedRecipients, subject,
  } = params

  // @ts-expect-error TS2339
  const { applicationUrl } = generateApplicationUrl({
    applicationKey: 'realhub',
    // @ts-expect-error TS2322
    environment: process.env.REACT_APP_APPLICATION_ENV,
  })

  // We can only select users when sharing the dashboard link
  const recipients = selectedRecipients.map(recipient => ({
    // @ts-expect-error TS2339
    is_custom: recipient.is_custom || false,
    email: recipient.email,
    user_id: recipient.id,
  }))

  const emailParams = {
    message,
    redirect_url: `${applicationUrl}/#/campaigns/${campaign.id}/edit/${linkAnchor}`,
    recipients,
    subject,
    complete_selection: completeSelection,
  }

  const emailDashboardLinkPayload = {
    callbacks: {
      action: emailFn,
      afterAction: closeModal,
    },
    entityParams: emailParams,
    toastText: 'Email Sent',
  }

  swal.fire({
    confirmButtonColor: '#43ac6a',
    confirmButtonText: 'Yes, send it.',
    icon: 'success',
    reverseButtons: true,
    showCancelButton: true,
    text: 'Are you sure? This campaign share link will be sent via email to the selected recipients.',
    title: 'Share Link?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      emailDashboardLink(emailDashboardLinkPayload)
    }
  })
}

interface ShareMediaSelectorButtonProps {
  callbacks: ModalCallbacks,
  campaign: CampaignModel,
  hookPayload: UseSelectEmailRecipientModalPayload,
  linkAnchor: string,
  completeSelection?: boolean,
}

const ShareMediaSelectorButton = (props: ShareMediaSelectorButtonProps) => {
  const {
    callbacks, campaign, hookPayload, linkAnchor, completeSelection,
  } = props
  const { closeModal, emailDashboardLink } = callbacks

  const {
    hasSelectedUsers,
    message,
    selectedRecipients,
    subject,
  } = hookPayload

  const {
    callbacks: {
      emailDashboardLink: emailFn,
    },
    creating,
  } = useCampaign(campaign)

  return (
    <Button
      buttonStyle="primaryCreate"
      disabled={!hasSelectedUsers}
      loading={creating}
      onClick={() => confirmShareLink({
        campaign,
        closeModal,
        completeSelection,
        emailFn,
        emailDashboardLink,
        linkAnchor,
        message,
        selectedRecipients,
        subject,
      })}
      size="large"
    >
      {hasSelectedUsers ? 'Send Message' : 'Add Recipient'}
    </Button>
  )
}

export default ShareMediaSelectorButton
